'use client';
import classNames from 'classnames';
import { FC, useEffect, useState } from 'react';

import type { ArticleTag } from '@/entities/article';
import { MIN_SHOW_TAGS } from '@/entities/article';
import ShowMore from '@/features/showMore/ShowMore';
import TagList from '@/widgets/tagList/TagList';

import styles from './tagFilters.module.scss';

interface TagFiltersProps {
  tags: ArticleTag[];
  className?: string;
  selectedTags?: string[];
  onChooseTag: (tags: string[]) => void;
}

const TagFilters: FC<TagFiltersProps> = (props) => {
  const { tags, className, selectedTags, onChooseTag } = props;
  const [activeMoreList, setActiveMoreList] = useState(false);

  useEffect(() => {
    setActiveMoreList(Boolean(selectedTags?.length));
  }, [selectedTags]);

  function renderTags() {
    if (activeMoreList) {
      return tags;
    }

    return tags.slice(0, MIN_SHOW_TAGS);
  }

  function toggleOpenList() {
    setActiveMoreList((prev) => !prev);
  }

  return (
    <aside className={classNames(className, styles.container)}>
      <div className={styles.container__headBlock}>
        <p className={styles.container__head}>Теги</p>
      </div>
      <TagList
        className={styles.container__list}
        selectedTags={selectedTags}
        tags={renderTags()}
        onChooseTag={onChooseTag}
      />
      {tags.length > MIN_SHOW_TAGS && (
        <ShowMore active={activeMoreList} onClick={toggleOpenList} />
      )}
    </aside>
  );
};

export default TagFilters;
